/**
 * Homepage Preferences Manager
 *
 * Helper function for homepage updates.
 */

import { FORCE_SHOPPING_PREFS_MODAL_PATHNAME } from '@constants/user-shopping-preferences';
import { ShoppingPrefsPayload } from '@lib/shopping-preferences/types';

/**
 * Update homepage with new preferences (client-side redirect)
 *
 * @param preferences - New preferences to apply
 */
export const updateHomepageWithPreferences = (preferences: ShoppingPrefsPayload): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const currentUrl = window.location.href;
  const isHomepage =
    window.location.pathname === '/' || window.location.pathname === FORCE_SHOPPING_PREFS_MODAL_PATHNAME;

  // Only redirect if on homepage and universe changed
  if (isHomepage && preferences?.universe) {
    const url = new URL(currentUrl);
    const currentUniverse = url.searchParams.get('universe');

    if (currentUniverse !== String(preferences.universe)) {
      window.location.assign(`/?universe=${preferences.universe}`);
    }
  }
};
